import { BigBashEvent } from "@/types/types";
import { TypeConversionManager } from "@/utils/TypeConversionManager";
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EventFormSectionStyles } from "./SectionStyles";

@customElement("basic-info-section")
class BasicInfoSection extends LitElement {
	static readonly styles = [EventFormSectionStyles];

	@property({ type: Object }) values: Partial<BigBashEvent> = {};

	private conversionManager = new TypeConversionManager();

	render() {
		return html`
			<div class="form-section">
				<p class="form-section-title">📅 Event Grunddaten</p>
				<div class="form-row">
					<basic-input 
						helperText="Name der Gruppe oder Organisation" 
						label="Gruppenname" 
						name="name" 
						style="flex: 1;"
						value="${this.values?.name || ''}"
					></basic-input>
				</div>
				<div class="form-row">
					<basic-datetime-input
						helperText="Datum und Uhrzeit des Events"
						label="Datum und Uhrzeit"
						name="datetime"
						style="flex: 1;"
						value="${this.conversionManager.convertDateToHTMLInputValue(this.values?.datetime) || ''}"
					></basic-datetime-input>
					<basic-number-input 
						helperText="Geschätzte Spieldauer in Minuten" 
						label="Dauer (Minuten)" 
						name="duration" 
						style="flex: 1;"
						step="15"
						value="${this.values?.duration || ''}"
					></basic-number-input>
				</div>
			</div>
		`;
	}
}

export default BasicInfoSection;
